// 法语
export const French = {
  language_code: "fr",
  get_btn: "Recevez maintenant",
  unregistered_tip:
    "Les utilisateurs non enregistrés créeront directement un compte.",
  phone_number: "Numéro de téléphone",
  ver_code: "Code de vérification",
  get_ver_code: "Obtenez le code",
  retrieve_ver_code: "Réessayer ({SECONDS})",
  age_tip:
    "Je suis majeur(e) et dispose de la pleine capacité civile, et j'accepte ",
  and: " et ",
  PRIVICY_POLICY: '"Politique de confidentialité"',
  MEMBER_AGGREMENT: '"Conditions d\'adhésio"',
  agree_push:
    "J'accepte de recevoir les notifications Haidilao via mon numéro de téléphone ou mon e-mail enregistré.",
  CN: "Chine",
  US: "États-Unis",
  CA: "Canada",
  GB: "Royaume-Uni",
  MY: "Malaisie",
  AU: "Australie",
  ID: "Indonésie",
  SG: "Singapour",
  TH: "Thaïlande",
  JP: "Japon",
  KR: "Corée",
  VN: "Vietnam",
  HK: "Hong Kong",
  MO: "Macao",
  HKM: "Cambodge",
  TW: "Taïwan",
  PH: "Philippines",
  UAE: "Émirats arabes unis",
  suc_send: "Envoi réussi",
  suc_get: "Réception réussie",
  fail_ver_code: "Code incorrect",
  time_end: "L'événement est terminé",
  not_get_repeat: "Impossible de recevoir à nouveau !",
  not_get_eligible: "Impossible de recevoir, non éligible pour l'événement.",
  not_get_late: "Vous êtes arrivé trop tard, l'événement est terminé.",
  get_coupon: "Obtenir l’offre",
  phone_err: "Numéro de téléphone invalide. Veuillez saisir un numéro valide.",
  page_title: "Récupérer le coupon exclusif Haidilao",
  send_code_error: "Erreur d'envoi du code de vérification",
  network_error:
    "Votre connexion réseau est instable, veuillez réessayer plus tard.",
  member_status_abnormal: "Compte de membre en erreur, impossible de réclamer",
  send_frequently:
    "Trop de codes de vérification ont été envoyés. Entrez le dernier code reçu ou réessayez plus tard.",
  activity_boom: "Trop de réclamations. Veuillez réessayer plus tard.",
  email: "Email",
  email_error_tip:
    "Adresse e-mail invalide. Veuillez saisir une adresse valide.",
  suc_get_dialog_text:
    "Ouvrez immédiatement l'application Haidilao Membership pour voir vos coupons reçus !",
  btn_sure: "OK",
  btn_cancel: "Annuler",
  suc_dialog_text:
    "Ouvrez l’application Haidilao ou liez votre compte membre à LINE pour voir vos coupons reçus!",
  btn_return: "Retour",
  btn_download: "Télécharger",
};
